import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "history",
  "use": "history-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"history\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 14h8L5 6v8z\" /><path d=\"M25 22.558l10.633 3.545-1.266 3.794L21 25.442V16h4v6.558z\" /><path d=\"M10.271 11.272L7.444 8.443c8.592-8.59 22.523-8.59 31.114 0 8.59 8.592 8.59 22.523 0 31.114-8.591 8.59-22.522 8.59-31.114 0l2.829-2.829c7.03 7.03 18.427 7.03 25.456 0 7.03-7.029 7.03-18.427 0-25.456-7.029-7.03-18.427-7.03-25.457 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol